<div class="p-grid">
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div class="h4 text-uppercase">menu view</div>
		<div>Display Unavailable Timed Canvases</div>
		<div class="descriptionText">Time Range controlled canvases will be displayed or hidden from the guest based on this selection.</div>
		<div class="mb-3">
			<p-inputSwitch
				(onChange)="changesToSaveChange.emit(true)"
				[(ngModel)]="venueSvc.ooVenue.displayUnavailableTimedCanvas"
				pTooltip="Time Range controlled canvases will be displayed or hidden from the guest based on this selection."
			>
			</p-inputSwitch>
		</div>
		<div>Display Out of Stock Items?'</div>
		<div style="font-size: x-small">Items will be displayed online even if they're out of stock.</div>
		<div class="mb-3">
			<p-inputSwitch
				(onChange)="changesToSaveChange.emit(true)"
				[(ngModel)]="venueSvc.ooVenue.displayOutOfStockItems"
				pTooltip="Items will be displayed online even if they are out of stock. If turned off, out of stock items will not show online. You can use this in conjunction with 'Display Out of Stock Item Status online' to prevent orderers from ringing out of stock items."
			>
			</p-inputSwitch>
		</div>
		<div>Display Out of Stock item badge</div>
		<div>
			<p-tag styleClass="me-2 ms-auto" value="Out of Stock" severity="danger" [rounded]="true"> </p-tag>
		</div>
		<div style="font-size: x-small">Out of stock items will be displayed with a badge</div>
		<div class="mb-3">
			<p-inputSwitch
				(onChange)="changesToSaveChange.emit(true)"
				[disabled]="!venueSvc.ooVenue.displayOutOfStockItems"
				[(ngModel)]="venueSvc.ooVenue.displayOutOfStockItemStatus"
				pTooltip="When an item is out of stock, it will be shown with an Out of Stock Badge and cannot be ordered. With this setting off, out of stock items will appear like regular items and can be ordered."
			>
			</p-inputSwitch>
		</div>
		<div>Display Limited Availability badge</div>
		<div>
			<p-tag styleClass="me-2 ms-auto" [value]="venueSvc.ooVenue.limitedAvailabilityTag" severity="warning" [rounded]="true"> </p-tag>
		</div>
		<div style="font-size: x-small">Items that are marked at <i>Countdown</i> in Focus will have this tag.</div>
		<div class="mb-3">
			<p-inputSwitch
				(onChange)="changesToSaveChange.emit(true)"
				[(ngModel)]="venueSvc.ooVenue.displayCountdownItemStatus"
				pTooltip="When an item is set for Countdown in Focus, a badge will be displayed when ordering."
			>
			</p-inputSwitch>
		</div>
		<div class="mb-3">
			<input
				pInputText
				class="w-100"
				type="text"
				placeholder="Limited availability"
				name="limitedAvailabilityTag"
				[(ngModel)]="venueSvc.ooVenue.limitedAvailabilityTag"
				class="w-100"
				[disabled]="!venueSvc.ooVenue.displayCountdownItemStatus"
				pTooltip="Customize the tag that is displayed when an item is on Countdown"
				(change)="changesToSaveChange.emit(true)"
			/>
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div class="h4 text-uppercase">item view</div>
		<div>Display Unavailable Timed Items</div>
		<div class="descriptionText">Time Range controlled items will be displayed or hidden from the guest based on this selection.</div>
		<div class="mb-3">
			<p-inputSwitch
				(onChange)="changesToSaveChange.emit(true)"
				[(ngModel)]="venueSvc.ooVenue.displayUnavailableTimedItem"
				pTooltip="Time Range controlled items will be displayed or hidden from the guest based on this selection."
			>
			</p-inputSwitch>
		</div>
		<div>Display Modifier Out of Stock badge</div>
		<div>
			<p-tag styleClass="me-2 ms-auto" value="Out of Stock" severity="danger" [rounded]="true"> </p-tag>
		</div>
		<div style="font-size: x-small">Out of stock modifier will be displayed with a badge</div>
		<div class="mb-3">
			<p-inputSwitch
				(onChange)="changesToSaveChange.emit(true)"
				[disabled]="!venueSvc.ooVenue.displayOutOfStockItems"
				[(ngModel)]="venueSvc.ooVenue.displayOutOfStockModifierStatus"
				pTooltip="When a modifier is out of stock, it will be shown with an Out of Stock Badge and cannot be used on the menu item. With this setting off, out of stock items will appear like regular modifiers and can be used."
			>
			</p-inputSwitch>
		</div>
		<div>Display Menu Item 'Special Instructions'</div>
		<div class="mb-3">
			<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="venueSvc.ooVenue.displaySpecialInstructions"> </p-inputSwitch>
		</div>
		<div>Display Menu Item 'Who Is This For?'</div>
		<div class="mb-3">
			<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="venueSvc.ooVenue.displayWhoThisFor"> </p-inputSwitch>
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>
			<img
				class="w-100 mb-3"
				[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueSvc.venueKey + '/default.png?' + timestamp"
				onError="this.src='https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/no-image-found-360x250.png'"
			/>
			<div class="mb-3">
				<p-button pRipple styleClass="p-button-raised w-100" (click)="selectImage('default')">
					<ng-template pTemplate="content">
						<fa-icon [icon]="['far', 'images']" size="lg" class="ms-1 me-2"></fa-icon>
						Edit Default Image
					</ng-template>
				</p-button>
			</div>
		</div>
		<div>
			<img
				class="w-100 mb-3"
				[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueSvc.venueKey + '/promo.png?' + timestamp"
				onError="this.src='https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/no-image-found-360x250.png'"
			/>
			<div class="mb-3 d-flex">
				<div class="mx-2">
					<p-button pRipple styleClass="p-button-raised w-100" (click)="selectImage('promo')">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'images']" size="lg" class="ms-1 me-2"></fa-icon>
							Edit Promo Image
						</ng-template>
					</p-button>
				</div>
				<div class="mx-2">
					<p-button pRipple styleClass="p-button-raised p-button-danger w-100" (click)="deletePromoImage()">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1 me-2"></fa-icon>
							Delete Image
						</ng-template>
					</p-button>
				</div>
			</div>
			<div>Display Promo Image</div>
			<div class="mb-3">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="venueSvc.ooVenue.displayPromo"></p-inputSwitch>
			</div>
		</div>
	</div>
</div>
